<kort id="gruppe-roller" #kort>
  <kort-tittel>
    {{ 'Roller' | translate }}
    <div class="antall">{{ '{antall} roller' | translate: {antall: roller().length} }}</div>
  </kort-tittel>

  @if (visning()) {
    @if (!kort.erAktiv()) {
      <p>{{ 'Bruk roller til å angi gruppemedlemmenes formelle rolle i gruppen, feks styreleder, varamedlem etc.' | translate }}</p>
      <kort-handlinger>
        <button mat-button (click)="visDetaljer()" data-testid="vis-alle-knapp">
          <mat-icon>list</mat-icon>
          {{ 'Vis alle' | translate }}
        </button>
      </kort-handlinger>

    } @else {
      <div class="innhold-kontainer">
        <table>
          <thead>
          <tr>
            <th>{{ 'Tittel' | translate }}</th>
            <th>{{ 'I bruk' | translate }}</th>
          </tr>
          </thead>
          <tbody>
            @for (rolle of roller(); track rolle.id) {
              <tr data-testid="rolle">
                <td data-testid="navn">{{ rolle.tittel }}</td>
                <td>
                  <mat-icon>{{ rolle.kanIkkeSlettes ? 'check_circle' : 'circle' }}</mat-icon>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <kort-handlinger>
        <button mat-button (click)="skjulDetaljer()">{{ 'Skjul' | translate }}</button>
        <button mat-button (click)="rediger()" data-testid="rediger-knapp">
          <mat-icon>edit</mat-icon>
          {{ 'Rediger' | translate }}
        </button>
      </kort-handlinger>
    }

  } @else {
    <gruppe-rolle-rediger-liste
            [roller]="roller()"
            [gruppeId]="gruppeId()"
            (vedFerdig)="redigeringFerdig($event)"/>
  }
</kort>
